import { useGetApplicableScenariosQuery, useGetScenariosQuery } from "api/TenantSlug/ConnectionCreator/hooks";
import { useMemo } from "react";

import FilterRequest = App.Http.Requests.FilterRequest;

interface UseScenarioSelectOptionsProps {
    enabled?: boolean;
    filter?: FilterRequest;
    formStructureId?: string;
}

export const useScenarioSelectOptions = ({
    enabled = true,
    filter,
    formStructureId,
}: UseScenarioSelectOptionsProps = {}) => {
    const applicableScenariosQuery = useGetApplicableScenariosQuery(
        {
            form_structure_id: formStructureId ?? "",
            filter,
        },
        { enabled: enabled && !!formStructureId }
    );
    const allScenariosQuery = useGetScenariosQuery(
        {
            filter,
        },
        { enabled: enabled && !formStructureId }
    );

    const data = formStructureId ? applicableScenariosQuery.data : allScenariosQuery.data;
    const isLoading = formStructureId ? applicableScenariosQuery.isLoading : allScenariosQuery.isLoading;
    const error = formStructureId ? applicableScenariosQuery.error : allScenariosQuery.error;

    const options = useMemo(() => {
        if (!data?.scenarios) return [];

        return data.scenarios.map((scenario) => ({
            label: scenario.title,
            value: scenario.id,
        }));
    }, [data?.scenarios]);

    return {
        options,
        loading: isLoading,
        error: error ? String(error) : null,
    };
};
